/* eslint-disable react/prop-types */
import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useEffect } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import {
  FormControlLabel,
  Pagination,
  Stack,
  Grid,
  useMediaQuery,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { makeStyles, useTheme } from '@mui/styles';
import { visuallyHidden } from '@mui/utils';
import Avatar from 'antd/es/avatar/avatar';
import {
  getApiCall,
  getBuyerDetails,
  getTagDetails,
  getusertagDetails,
} from 'api/apiService';
import {
  displayFlex,
  imageCont,
  userDetCont,
} from 'component/ActivityContainer/ActivityContainer.style';
import { BuyersCard } from 'component/BuyersCard/BuyersCard';
import { Feedback } from 'component/BuyersCard/Feedback';
import OwnerCard from 'component/OwnerCard/OwnerCard';
import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { fontsize10, poppins400 } from 'theme/common.style';
import {
  ActionContainer,
  Contact,
  ExpCardData,
  ValueForming,
} from './BuyerTabItem.util';
import { CategoryContainer, TagContainer } from './ContactTabItem.util';
import { checkbox_style } from './Table.style';
import { GET_BINDERID } from 'constant/app.config';
import Popover from '@mui/material/Popover';
import { TagPopOver } from './Table';
import moment from 'moment';
import Moxochat from 'component/Moxochat/Moxochat';
import { datacontext } from 'modules/AppLayout/AppLayout';

export const Search = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 8.15346C0 3.69924 3.69241 0.0883789 8.24723 0.0883789C12.8021 0.0883789 16.4945 3.69924 16.4945 8.15346C16.4945 12.6077 12.8021 16.2185 8.24723 16.2185C3.69241 16.2185 0 12.6077 0 8.15346ZM15.2243 8.15359C15.2243 4.38544 12.1006 1.33074 8.24734 1.33074C4.39409 1.33074 1.27041 4.38544 1.27041 8.15359C1.27041 11.9217 4.39409 14.9764 8.24734 14.9764C12.1006 14.9764 15.2243 11.9217 15.2243 8.15359Z"
        fill="#666666"
      />
      <path
        d="M14.1743 14.1758C14.3861 13.9631 14.7178 13.9434 14.9518 14.1168L15.0188 14.1747L17.8246 16.9782C18.0581 17.2115 18.0585 17.5903 17.8257 17.8242C17.6139 18.0369 17.2822 18.0566 17.0482 17.8832L16.9812 17.8253L14.1754 15.0218C13.9419 14.7885 13.9415 14.4097 14.1743 14.1758Z"
        fill="#666666"
      />
      <path
        d="M8 4V9L11 12"
        stroke="#666666"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, headCells } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {/* <TableCell padding="checkbox"></TableCell> */}
        {headCells?.map((headCell, index) => (
          <TableCell
            key={headCell.id}
            // align={headCell.numeric ? "right" : "left"}
            align="left"
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ ...poppins400, ...fontsize10, color: '#666666' }}
          >
            <TableSortLabel
              sx={{ marginLeft: index == 0 ? '54px' : '0px' }}
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  headCells: PropTypes.string.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected } = props;

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          {/* Nutrition */}
        </Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const BedIcon = () => {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.74464 7.39211H14.255C14.7706 7.39211 15.1886 6.97413 15.1886 6.45851C15.1886 5.94288 14.7706 5.5249 14.255 5.5249H1.74464C1.22901 5.5249 0.811035 5.94288 0.811035 6.45851C0.811006 6.97413 1.22901 7.39211 1.74464 7.39211Z"
        fill="#6C2AD2"
      />
      <path
        d="M8.9336 3.51123C8.66111 3.51123 8.43945 3.73289 8.43945 4.00538V4.64602H12.2638V4.00538C12.2638 3.73289 12.0422 3.51123 11.7697 3.51123H8.9336Z"
        fill="#6C2AD2"
      />
      <path
        d="M2.85707 4.00547C2.85707 3.24835 3.47301 2.63241 4.23013 2.63241H7.06621C7.4265 2.63241 7.75463 2.7721 7.99981 2.99991C8.245 2.7721 8.57312 2.63241 8.93342 2.63241H11.7695C12.5266 2.63241 13.1426 3.24835 13.1426 4.00547V4.6461H14.569V1.61915C14.569 1.10353 14.151 0.685547 13.6354 0.685547H2.36427C1.84864 0.685547 1.43066 1.10353 1.43066 1.61915V4.6461H2.85707V4.00547Z"
        fill="#6C2AD2"
      />
      <path
        d="M4.23048 3.51123C3.95799 3.51123 3.73633 3.73289 3.73633 4.00538V4.64602H7.56071V4.00538C7.56071 3.73289 7.33905 3.51123 7.06656 3.51123H4.23048Z"
        fill="#6C2AD2"
      />
      <path
        d="M0.5 8.271V12.3145H1.37891V10.712H14.6211V12.3145H15.5V8.271H0.5Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};

const ShowerIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9667 0C13.5249 0 13.1667 0.358167 13.1667 0.8V1.06667H7.30007C6.56406 1.06753 5.9676 1.664 5.96673 2.4V3.73333H5.4334C4.99156 3.73333 4.6334 4.0915 4.6334 4.53333V5.452C3.47183 6.16797 2.76513 7.4355 2.76673 8.8V9.11573C2.44823 9.22833 2.2348 9.52887 2.2334 9.86667V10.4C2.2334 10.5473 2.3528 10.6667 2.50007 10.6667H11.0334C11.1807 10.6667 11.3001 10.5473 11.3001 10.4V9.86667C11.2987 9.52887 11.0852 9.22833 10.7667 9.11573V8.8C10.7683 7.73813 10.346 6.71957 9.5934 5.9704C9.38426 5.76873 9.15143 5.59313 8.90006 5.44747V4.53333C8.90006 4.0915 8.5419 3.73333 8.10006 3.73333H7.56673V2.93333C7.56673 2.78607 7.68613 2.66667 7.8334 2.66667H13.1667V3.2C13.1667 3.64183 13.5249 4 13.9667 4H14.7667V0H13.9667ZM10.7667 9.86667V10.1333H2.76673V9.86667C2.76673 9.7194 2.88613 9.6 3.0334 9.6H10.5001C10.6473 9.6 10.7667 9.7194 10.7667 9.86667ZM9.21767 6.34827C9.86933 6.99757 10.2349 7.88007 10.2334 8.8V9.06667H3.30007V8.8C3.2992 7.59507 3.9354 6.47947 4.97287 5.86667H8.56246C8.801 5.99783 9.0213 6.15973 9.21767 6.34827ZM8.10006 4.26667C8.24733 4.26667 8.36673 4.38607 8.36673 4.53333V5.33333H5.16673V4.53333C5.16673 4.38607 5.28613 4.26667 5.4334 4.26667H8.10006ZM13.1667 2.13333H7.8334C7.39156 2.13333 7.0334 2.4915 7.0334 2.93333V3.73333H6.50006V2.4C6.50006 1.95817 6.85823 1.6 7.30007 1.6H13.1667V2.13333ZM14.2334 3.46667H13.9667C13.8195 3.46667 13.7001 3.34727 13.7001 3.2V0.8C13.7001 0.652733 13.8195 0.533333 13.9667 0.533333H14.2334V3.46667Z"
        fill="#6C2AD2"
      />
      <path
        d="M6.76667 11.2002C6.6194 11.2002 6.5 11.3196 6.5 11.4669V12.5335C6.5 12.6808 6.6194 12.8002 6.76667 12.8002C6.91393 12.8002 7.03333 12.6808 7.03333 12.5335V11.4669C7.03333 11.3196 6.91393 11.2002 6.76667 11.2002Z"
        fill="#6C2AD2"
      />
      <path
        d="M6.76667 13.3335C6.6194 13.3335 6.5 13.4529 6.5 13.6002V14.6668C6.5 14.8141 6.6194 14.9335 6.76667 14.9335C6.91393 14.9335 7.03333 14.8141 7.03333 14.6668V13.6002C7.03333 13.4529 6.91393 13.3335 6.76667 13.3335Z"
        fill="#6C2AD2"
      />
      <path
        d="M9.96686 12.2666C9.8196 12.2666 9.7002 12.386 9.7002 12.5333V13.5999C9.7002 13.7472 9.8196 13.8666 9.96686 13.8666C10.1141 13.8666 10.2335 13.7472 10.2335 13.5999V12.5333C10.2335 12.386 10.1141 12.2666 9.96686 12.2666Z"
        fill="#6C2AD2"
      />
      <path
        d="M7.83356 12.2666C7.68629 12.2666 7.56689 12.386 7.56689 12.5333V13.5999C7.56689 13.7472 7.68629 13.8666 7.83356 13.8666C7.98083 13.8666 8.10023 13.7472 8.10023 13.5999V12.5333C8.10023 12.386 7.98083 12.2666 7.83356 12.2666Z"
        fill="#6C2AD2"
      />
      <path
        d="M5.69977 12.2666C5.55251 12.2666 5.43311 12.386 5.43311 12.5333V13.5999C5.43311 13.7472 5.55251 13.8666 5.69977 13.8666C5.84704 13.8666 5.96644 13.7472 5.96644 13.5999V12.5333C5.96644 12.386 5.84704 12.2666 5.69977 12.2666Z"
        fill="#6C2AD2"
      />
      <path
        d="M3.56647 12.2666C3.4192 12.2666 3.2998 12.386 3.2998 12.5333V13.5999C3.2998 13.7472 3.4192 13.8666 3.56647 13.8666C3.71374 13.8666 3.83314 13.7472 3.83314 13.5999V12.5333C3.83314 12.386 3.71374 12.2666 3.56647 12.2666Z"
        fill="#6C2AD2"
      />
      <path
        d="M4.63337 11.2002C4.4861 11.2002 4.3667 11.3196 4.3667 11.4669V12.5335C4.3667 12.6808 4.4861 12.8002 4.63337 12.8002C4.78063 12.8002 4.90003 12.6808 4.90003 12.5335V11.4669C4.90003 11.3196 4.78063 11.2002 4.63337 11.2002Z"
        fill="#6C2AD2"
      />
      <path
        d="M8.89997 11.2002C8.7527 11.2002 8.6333 11.3196 8.6333 11.4669V12.5335C8.6333 12.6808 8.7527 12.8002 8.89997 12.8002C9.04723 12.8002 9.16663 12.6808 9.16663 12.5335V11.4669C9.16663 11.3196 9.04723 11.2002 8.89997 11.2002Z"
        fill="#6C2AD2"
      />
      <path
        d="M8.89997 13.3335C8.7527 13.3335 8.6333 13.4529 8.6333 13.6002V14.6668C8.6333 14.8141 8.7527 14.9335 8.89997 14.9335C9.04723 14.9335 9.16663 14.8141 9.16663 14.6668V13.6002C9.16663 13.4529 9.04723 13.3335 8.89997 13.3335Z"
        fill="#6C2AD2"
      />
      <path
        d="M4.63337 13.3335C4.4861 13.3335 4.3667 13.4529 4.3667 13.6002V14.6668C4.3667 14.8141 4.4861 14.9335 4.63337 14.9335C4.78063 14.9335 4.90003 14.8141 4.90003 14.6668V13.6002C4.90003 13.4529 4.78063 13.3335 4.63337 13.3335Z"
        fill="#6C2AD2"
      />
      <path
        d="M5.69977 14.3999C5.55251 14.3999 5.43311 14.5193 5.43311 14.6666V15.7332C5.43311 15.8805 5.55251 15.9999 5.69977 15.9999C5.84704 15.9999 5.96644 15.8805 5.96644 15.7332V14.6666C5.96644 14.5193 5.84704 14.3999 5.69977 14.3999Z"
        fill="#6C2AD2"
      />
      <path
        d="M7.83356 14.3999C7.68629 14.3999 7.56689 14.5193 7.56689 14.6666V15.7332C7.56689 15.8805 7.68629 15.9999 7.83356 15.9999C7.98083 15.9999 8.10023 15.8805 8.10023 15.7332V14.6666C8.10023 14.5193 7.98083 14.3999 7.83356 14.3999Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};

const CarIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_24664_159013)">
        <path
          d="M13.2647 7.79749C13.2068 7.79749 13.1474 7.80581 13.0879 7.82213L12.4161 8.0072L11.7185 6.30774C11.5208 5.82631 10.9366 5.43457 10.4162 5.43457H3.88722C3.36675 5.43457 2.7826 5.82631 2.58498 6.30774L1.88829 8.00482L1.22476 7.82206C1.16538 7.80575 1.10594 7.79742 1.04801 7.79742C0.730447 7.79742 0.5 8.04002 0.5 8.37417V8.7702C0.5 9.16029 0.817434 9.47772 1.20752 9.47772H1.28354L1.17093 9.75203C0.987313 10.1992 0.837843 10.9565 0.837843 11.4401V14.8162C0.837843 15.2063 1.15528 15.5238 1.54536 15.5238H2.4694C2.85949 15.5238 3.17692 15.2063 3.17692 14.8162V13.9732H11.1264V14.8162C11.1264 15.2063 11.4439 15.5238 11.834 15.5238H12.7579C13.1479 15.5238 13.4654 15.2063 13.4654 14.8162V11.4402C13.4654 10.9566 13.3159 10.1993 13.1323 9.75209L13.0197 9.47779H13.1051C13.4952 9.47779 13.8127 9.16035 13.8127 8.77027V8.37423C13.8127 8.04009 13.5822 7.79749 13.2647 7.79749ZM2.39549 9.09351L3.45083 6.523C3.56905 6.23502 3.92044 5.99936 4.23173 5.99936H10.0717C10.383 5.99936 10.7344 6.23496 10.8526 6.523L11.9079 9.09351C12.0261 9.38149 11.8682 9.61715 11.5569 9.61715H2.74661C2.43525 9.61709 2.27733 9.38149 2.39549 9.09351ZM4.75127 12.3449C4.75127 12.5006 4.62386 12.6279 4.46832 12.6279H2.46358C2.30791 12.6279 2.18056 12.5005 2.18056 12.3449V11.3829C2.18056 11.2272 2.30791 11.0999 2.46358 11.0999H4.46832C4.62386 11.0999 4.75127 11.2272 4.75127 11.3829V12.3449ZM12.1038 12.3449C12.1038 12.5006 11.9764 12.6279 11.8209 12.6279H9.81615C9.6606 12.6279 9.53319 12.5005 9.53319 12.3449V11.3829C9.53319 11.2272 9.6606 11.0999 9.81615 11.0999H11.8209C11.9764 11.0999 12.1038 11.2272 12.1038 11.3829V12.3449Z"
          fill="#6C2AD2"
        />
        <path
          d="M17.6149 2.47607H14.2638C13.7759 2.47607 13.3789 2.8731 13.3789 3.361V6.71209C13.3789 7.20006 13.7759 7.59709 14.2638 7.59709H15.6091V15.1183C15.6091 15.3007 15.7569 15.4485 15.9393 15.4485C16.1217 15.4485 16.2696 15.3007 16.2696 15.1183V7.59715H17.6149C18.1028 7.59715 18.4998 7.20013 18.4998 6.71216V3.36107C18.4998 2.8731 18.1028 2.47607 17.6149 2.47607ZM16.8559 5.25458C16.6632 5.42809 16.3793 5.51607 16.0122 5.51607H15.5269C15.4686 5.51607 15.4212 5.56356 15.4212 5.62181V6.4401C15.4212 6.529 15.3489 6.60126 15.26 6.60126H14.8925C14.8035 6.60126 14.7313 6.52894 14.7313 6.4401V3.63333C14.7313 3.54436 14.8036 3.47203 14.8925 3.47203H15.8182C16.4315 3.47203 16.6604 3.56444 16.8486 3.72408C17.047 3.89244 17.1475 4.1503 17.1475 4.49065C17.1474 4.82321 17.0494 5.08014 16.8559 5.25458Z"
          fill="#6C2AD2"
        />
        <path
          d="M16.3308 4.14983C16.2412 4.0822 16.0827 4.04785 15.8599 4.04785H15.5271C15.4688 4.04785 15.4214 4.09528 15.4214 4.15346V4.82598C15.4214 4.88417 15.4688 4.93159 15.5271 4.93159H15.7265C15.7997 4.93159 15.9181 4.92618 15.9903 4.91951C16.0603 4.9131 16.2582 4.88443 16.3308 4.82961C16.4179 4.7637 16.4621 4.64969 16.4621 4.49085C16.4621 4.33048 16.4179 4.21575 16.3308 4.14983Z"
          fill="#6C2AD2"
        />
      </g>
      <defs>
        <clipPath id="clip0_24664_159013">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default function EnhancedBuyerTable(props) {
  const { setIschatopen } = React.useContext(datacontext);
  const [selectedBuyers, setSelectedBuyers] = React.useState([]);
  const data = props.properties?.userDetails
    ? props.properties?.userDetails
    : props.properties?.data;
  const [openFeedback, setOpenFeedback] = useState(false);
  const [selectedBuyerId, setSelectedBuyerId] = React.useState('');
  const [expandFeedback, setExpandFeedback] = React.useState(false);
  const [buyerId, setBuyerId] = React.useState('');
  const [isModalOpen, setIsModalOpen] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [userType, setUserType] = React.useState(false);
  const {
    headCells,
    setProperties,
    setSelectedRows,
    selectedRows = [],
  } = props;
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(1);
  const [indexValue, setIndexValue] = React.useState(null);
  const [isHiddenRightArrow, setIsHiddenRightArrow] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(null);
  const [totalPages, setTotalpages] = useState(1);
  const [row, setRow] = React.useState({});
  const [position, setPosition] = useState(0);
  const [showBackdrop, setShowBackDrop] = React.useState(false);
  const [arrayCollection, setArrayCollection] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [postTagId, setPostTagId] = useState('');
  const [userName, setUserName] = useState('');
  const [userInitial, setUserInitial] = useState('');
  const [LoaderUser, setLoaderUser] = useState(false);
  const [LoaderTag, setLoaderTag] = useState(false);
  const [userTagDetails, setUserTagDetails] = useState([]);
  const [tagArray, setTagArray] = useState([]);
  const openPop = Boolean(anchorEl);
  const [feedBackData, setFeedBackData] = useState(null);
  const [userEmail, setUserEmail] = useState('');
  const idPop = open ? 'simple-popover' : undefined;
  const [address, setAddress] = useState();
  const [exportSelected, setExportSelected] = useState(selectedRows);
  const isUserAction = React.useRef(false);
  const isInitialRender = React.useRef(true);

  const getFirstValue = (value) => {
    if (!value) return 0;

    try {
      return JSON.parse(value)?.[0] ?? 0;
    } catch {
      return value.split('-')[0] || 0;
    }
  };

  const handleExportSelection = (buyerId, checked) => {
    let updated;

    if (checked) {
      updated = [...exportSelected, buyerId];
    } else {
      updated = exportSelected.filter((id) => id !== buyerId);
    }

    isUserAction.current = true;
    setExportSelected(updated);
    setSelectedRows(updated);

    setTimeout(() => {
      isUserAction.current = false;
    }, 200);
  };

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    if (isUserAction.current) {
      return;
    }

    setExportSelected(selectedRows);
  }, [selectedRows]);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const Apifunctions = async () => {
    setLoaderUser(true);
    setLoaderTag(true);
    let selecteddata = [];
    let alldata = [];
    await getusertagDetails(postTagId).then((res) => {
      if (res?.tagDetails?.length != 0) {
        selecteddata = res?.tagDetails;
        setUserTagDetails(res?.tagDetails);
        setLoaderUser(false);
      } else {
        setUserTagDetails(res?.tagDetails);
        setLoaderUser(false);
      }
    });
    await getTagDetails(postTagId).then((res) => {
      if (res?.status == 1) {
        setLoaderTag(false);
      } else {
        setLoaderTag(false);
      }
      alldata = res?.tagDetails;
      const results = alldata.filter(
        ({ tagName: id1 }) =>
          !selecteddata.some(({ tagName: id2 }) => id2 === id1)
      );
      setTagArray(results);
    });
  };

  const handleIconClick = (id, event, name) => {
    setUserName(name);
    setPostTagId(id);
    if (anchorEl == null) {
      setAnchorEl(event.currentTarget);
    } else {
      setAnchorEl(null);
    }
  };

  const collectId = (
    array,
    id,
    setBuyerId,
    setPosition,
    setArrayCollection
  ) => {
    let arrayCollection = [];
    if (array?.length > 0) {
      for (let index = 0; index < array?.length; index++) {
        const element = array[index]?.buyerDetails?.user?.userId;
        arrayCollection.push(element);
      }
      setArrayCollection(arrayCollection);
      // setBuyerId(id);

      let position = arrayCollection.indexOf(id);
      setPosition(position);
    }
  };
  const handlePageChange = (event, value) => {
    // setOffSet(page * 2);
    getBuyerDetails(value).then((resp) => {
      if (resp?.status == 1) {
        setPage(value);
        setProperties(resp);
        setIsModalOpen(() => resp?.userDetails?.map((i) => false));
      }
    });
  };
  const [errorMessage, setErrorMessage] = React.useState('');
  const getData = (page) => {
    var mounted = true;
    getBuyerDetails(page).then((resp) => {
      if (mounted) {
        if (resp.status === -1) {
          setErrorMessage('Buyer Not Available');
        } else {
          setIsModalOpen(() => resp?.userDetails?.map((i) => false));
          setProperties(resp);
          setTotalpages(resp?.userCount);
        }
      }
    });
    return () => (mounted = false);
  };

  React.useEffect(() => {
    getData(page);
  }, [page]);

  React.useEffect(() => {
    setArrayCollection(arrayCollection);
  }, [arrayCollection]);
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = data.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClickUserName = (
    isChecked,
    index,
    buyerId,
    userCategory = [],
    row,
    isPopupOpen
  ) => {
    setIsHiddenRightArrow(true);
    setIndexValue(index);
    setRow(row);

    const selectedIndex = selected.indexOf(index);
    let newSelected = [];
    setBuyerId(buyerId);
    setSelectedBuyerId(selectedBuyerId == buyerId ? '' : buyerId);
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, index);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    let userType = '';
    if (userCategory.length > 1) {
      userType = 'Both';
    } else if (userCategory.filter((e) => e.userType === 'Buyer').length > 0) {
      userType = 'Buyer';
    } else {
      userType = 'Owner';
    }

    setSelected(newSelected);
    setUserType(userType);

    if (userType == 'Both' || userType == 'Buyer') {
      setOpen(true);
    } else {
      setOpenOwner(true);
    }
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const [openOwner, setOpenOwner] = useState(false);

  const useStyles = makeStyles((theme) => ({
    root: {
      '& .MuiPaginationItem-root': {
        // styles for each pagination item
        color: '#9C9C9C',
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: '400px',
        margin: -3,
        padding: -3,
        // gap:9
      },
      '& .MuiPaginationItem-root.Mui-selected': {
        // styles for the currently selected pagination item
        backgroundColor: 'white',
        color: '#6C2AD2',
      },
      '& .MuiPaginationItem-icon': {
        color: 'rgba(20, 20, 43, 1)', // Customize the arrow color here
      },
    },
  }));
  const PGcolor = useStyles();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const onShowChat = (binderId) => {
    setIschatopen(binderId);
    setModalIsOpen(true);
  };

  const directcomm = (userId) => {
    const data = localStorage.getItem('userDetail');
    const userDetail = JSON.parse(data);
    const agentId = userDetail?.userId;
    const userTypeData = userDetail?.primaryUserType;

    if (userId) {
      getApiCall(
        GET_BINDERID + `/${agentId}` + `/${userId}` + `/0` + `/${userTypeData}`
      ).then((resp) => {
        onShowChat(resp?.data?.binderId);
      });
    }
  };

  const TimeAgo = ({ createdAt }) => {
    const createdAtMoment = moment(createdAt, 'YYYY-MM-DD HH:mm:ss');
    const currentTime = new Date(
      new Date().toLocaleString('en-US', { timeZone: 'Australia/Sydney' })
    );
    const timeDifference = currentTime - createdAtMoment;

    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    let timeAgo = '';

    if (seconds < 60) {
      timeAgo = `${seconds} second${seconds !== 1 ? 's' : ''} ago`;
    } else if (minutes < 60) {
      timeAgo = `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
    } else if (hours < 24) {
      timeAgo = `${hours} hour${hours !== 1 ? 's' : ''} ago`;
    } else {
      timeAgo = `${days} day${days !== 1 ? 's' : ''} ago`;
    }

    return (
      <Typography sx={{ ...poppins400, fontSize: '12px' }}>
        {timeAgo}
      </Typography>
    );
  };
  const [expandedRows, setExpandedRows] = useState({});

  const toggleRow = (index) => {
    setExpandedRows({
      ...expandedRows,
      [index]: !expandedRows[index],
    });
  };

  const toTitleCase = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <OwnerCard
          setSelectedBuyerId={setSelectedBuyerId}
          selectedBuyerId={selectedBuyerId}
          setSelectedBuyers={setSelectedBuyers}
          showBackdrop={showBackdrop}
          setShowBackDrop={setShowBackDrop}
          open={openOwner}
          setOpen={setOpenOwner}
          buyerId={buyerId}
          setOpenBuyer={setOpen}
          openBuyer={open}
          userType={userType}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          index={indexValue}
          isHiddenRightArrow={isHiddenRightArrow}
          setIsHiddenRightArrow={setIsHiddenRightArrow}
          arrayCollection={arrayCollection}
          setPosition={setPosition}
          setBuyerId={setBuyerId}
          setArrayCollection={setArrayCollection}
          data={data}
          position={position}
          setUserType={setUserType}
          rowData={row}
        />
        {data?.length > 0 && (
          <Paper sx={{ width: '100%', mb: 2 }}>
            <TableContainer style={{ border: '1px solid #D9D9D9' }}>
              <Table aria-labelledby="tableTitle" size="medium">
                <EnhancedTableHead
                  headCells={headCells}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {Array.isArray(data) ? (
                    data?.map((row, index) => {
                      const isItemSelected = isSelected(index);
                      const labelId = `enhanced-table-checkbox-${index}`;
                      const userCategory = row?.userCategory;
                      const buyerId = row?.user?.userId;
                      const searchListArray = row?.searchList?.searchList || [];
                      const isRowExpanded = expandedRows[index];
                      return (
                        <React.Fragment key={index}>
                          <TableRow
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={row.name}
                          >
                            <TableCell
                              component="th"
                              id={labelId}
                              scope="row"
                              padding="7px"
                            >
                              <Typography
                                sx={[userDetCont, { paddingLeft: '0' }]}
                              >
                                <Typography sx={imageCont}>
                                  {row?.user?.userProfile == '' ||
                                  row?.user?.userProfile == null ? (
                                    <Avatar
                                      style={{
                                        width: '29px',
                                        height: '29px',
                                        backgroundColor: '#666666',
                                        fontFamily: 'poppins',
                                        fontSize: '12px',
                                      }}
                                    >
                                      {row?.user?.userName
                                        ?.charAt(0)
                                        ?.toUpperCase() +
                                        row?.user?.userSurName
                                          ?.charAt(0)
                                          ?.toUpperCase()}
                                    </Avatar>
                                  ) : (
                                    <Avatar
                                      alt="Remy"
                                      src={row?.user?.userProfile}
                                      onClick={(event) => {
                                        handleClickUserName(
                                          event.target.checked,
                                          index,
                                          buyerId,
                                          userCategory,
                                          row,
                                          isPopupOpen,
                                          setShowBackDrop(false)
                                        );

                                        collectId(
                                          data,
                                          buyerId,
                                          setBuyerId,
                                          setPosition,
                                          setArrayCollection
                                        );
                                      }}
                                    />
                                  )}
                                  &nbsp;&nbsp;
                                  <Typography sx={displayFlex}>
                                    <Typography
                                      sx={{
                                        fontSize: '12px',
                                        fontFamily: 'Poppins',
                                        fontWeight: '400',
                                        cursor: 'pointer',
                                        whiteSpace: 'nowrap',
                                        color: '#112347',
                                      }}
                                      onClick={(event) => {
                                        handleClickUserName(
                                          event.target.checked,
                                          index,
                                          buyerId,
                                          userCategory,
                                          row,
                                          isPopupOpen,
                                          setShowBackDrop(false)
                                        );

                                        collectId(
                                          data,
                                          buyerId,
                                          setBuyerId,
                                          setPosition,
                                          setArrayCollection
                                        );
                                      }}
                                    >
                                      {toTitleCase(row?.user?.userName)}{' '}
                                      {toTitleCase(row?.user?.userSurName)}
                                    </Typography>
                                  </Typography>
                                </Typography>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              {<CategoryContainer data={row} />}
                            </TableCell>
                            <TableCell align="left" sx={{ padding: '7px' }}>
                              <Box
                                sx={{ display: 'flex', justifyContent: 'left' }}
                              >
                                {
                                  <Contact
                                    row={row}
                                    directcomm={directcomm}
                                    index={null}
                                  />
                                }
                              </Box>
                            </TableCell>

                            <TableCell align="left">
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'left',
                                  paddingRight: '15px',
                                }}
                              >
                                {row?.exp !== '' ? (
                                  <ExpCardData value={row?.exp} />
                                ) : (
                                  '-'
                                )}
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'left',
                                  paddingRight: '15px',
                                }}
                              >
                                {row?.profile !== '' ? (
                                  <ValueForming value={row?.profile} />
                                ) : (
                                  '-'
                                )}
                              </Box>
                            </TableCell>
                            <TableCell align="left" sx={{ maxWidth: '350px' }}>
                              {searchListArray.length > 0 ? (
                                <Swiper
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    alignItems: 'left',
                                    // gap: "10px",
                                    '--swiper-navigation-size': '16px',
                                  }}
                                  id="swiper"
                                  slidesPerView={1}
                                  navigation
                                >
                                  {searchListArray.length > 0 &&
                                    searchListArray.map((item, index) => (
                                      <SwiperSlide
                                        key={index}
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <Grid
                                          container
                                          sx={{
                                            flexDirection: 'column',
                                            width: '300px',
                                          }}
                                        >
                                          <Grid
                                            item
                                            sx={{
                                              display: 'flex',
                                              flexDirection: 'row',
                                              justifyContent: 'left',
                                              gap: '25px',
                                            }}
                                          >
                                            <Grid
                                              sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                gap: '10px',
                                              }}
                                            >
                                              {(() => {
                                                const bedroomValue =
                                                  getFirstValue(item?.bedroom);
                                                return bedroomValue > 0 ? (
                                                  <Box
                                                    sx={{
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                    }}
                                                  >
                                                    <BedIcon />
                                                    &nbsp;
                                                    <span
                                                      style={{
                                                        fontSize: '14px',
                                                        fontWeight: 400,
                                                        color: '#000000',
                                                      }}
                                                    >
                                                      {bedroomValue}
                                                    </span>
                                                  </Box>
                                                ) : null;
                                              })()}

                                              {(() => {
                                                const bathroomValue =
                                                  getFirstValue(item?.bathroom);
                                                return bathroomValue > 0 ? (
                                                  <Box
                                                    sx={{
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                    }}
                                                  >
                                                    <ShowerIcon />
                                                    &nbsp;
                                                    <span
                                                      style={{
                                                        fontSize: '14px',
                                                        fontWeight: 400,
                                                        color: '#000000',
                                                      }}
                                                    >
                                                      {bathroomValue}
                                                    </span>
                                                  </Box>
                                                ) : null;
                                              })()}

                                              {(() => {
                                                const parkingValue =
                                                  getFirstValue(item?.parking);
                                                return parkingValue > 0 ? (
                                                  <Box
                                                    sx={{
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                    }}
                                                  >
                                                    <CarIcon />
                                                    &nbsp;
                                                    <span
                                                      style={{
                                                        fontSize: '14px',
                                                        fontWeight: 400,
                                                        color: '#000000',
                                                      }}
                                                    >
                                                      {parkingValue}
                                                    </span>
                                                  </Box>
                                                ) : null;
                                              })()}
                                            </Grid>
                                            <Grid>
                                              <Typography
                                                sx={{
                                                  ...poppins400,
                                                  fontSize: '12px',
                                                }}
                                              >
                                                {item?.typeName}
                                              </Typography>
                                            </Grid>
                                          </Grid>
                                          <Grid item>
                                            <Stack
                                              direction={'column'}
                                              alignItems={'start'}
                                            >
                                              <Typography
                                                style={{
                                                  fontSize: '12px',
                                                  fontFamily: 'Poppins',
                                                  fontWeight: '400',
                                                  color: '#000000',
                                                }}
                                              >
                                                {item?.location}
                                              </Typography>
                                            </Stack>
                                          </Grid>
                                          <Grid
                                            item
                                            sx={{
                                              display: 'flex',
                                              flexDirection: 'row',
                                              justifyContent: 'left',
                                              gap: '20px',
                                            }}
                                          >
                                            <Grid>
                                              <Typography
                                                style={{
                                                  fontSize: '12px',
                                                  fontFamily: 'Poppins',
                                                  fontWeight: '400',
                                                  color: '#666',
                                                  marginTop: '10px',
                                                }}
                                              >
                                                {item?.priceRange}
                                              </Typography>
                                            </Grid>
                                            <Grid
                                              sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                                flexDirection: 'row',
                                                gap: '5px',
                                              }}
                                            >
                                              <Grid sx={{ marginTop: '5px' }}>
                                                <Search />
                                              </Grid>
                                              <Grid>
                                                <Typography
                                                  sx={{
                                                    ...poppins400,
                                                    fontSize: '12px',
                                                  }}
                                                >
                                                  <TimeAgo
                                                    createdAt={item?.createdAt}
                                                  />
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </SwiperSlide>
                                    ))}
                                </Swiper>
                              ) : (
                                <Box>-</Box>
                              )}
                            </TableCell>
                            <TableCell align="left" sx={{ padding: '7px' }}>
                              {
                                <TagContainer
                                  anchorEl={anchorEl}
                                  setAnchorEl={setAnchorEl}
                                  idPop={idPop}
                                  handleIconClick={handleIconClick}
                                  row={row}
                                  tagArray={tagArray}
                                  marginLeft={true}
                                />
                              }
                            </TableCell>
                            <TableCell align="left" sx={{ padding: '7px' }}>
                              {
                                <ActionContainer
                                  rowData={row}
                                  setFeedBackData={setFeedBackData}
                                  feedBackData={feedBackData}
                                  marginLeft={true}
                                  openFeedback={openFeedback}
                                  setOpenFeedback={setOpenFeedback}
                                  userName={userName}
                                  setUserType={setUserType}
                                  setUserName={setUserName}
                                  setBuyerId={setBuyerId}
                                  setUserEmail={setUserEmail}
                                  setUserInitial={setUserInitial}
                                />
                              }
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={5} />
                      {errorMessage && (
                        <div>
                          <Typography
                            sx={{
                              fontFamily: 'Poppins',
                              fontSize: '10px',
                              color: '#666666',
                              paddingLeft: '30px',
                            }}
                          >
                            {errorMessage}
                          </Typography>
                        </div>
                      )}
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        )}
      </Box>

      {selectedBuyers.length > 0 && showBackdrop ? (
        selectedBuyers.map((value, index, open = true) => {
          return (
            <>
              {!expandFeedback && (
                <BuyersCard
                  selectedBuyers={selectedBuyers}
                  setSelectedBuyers={setSelectedBuyers}
                  count={index}
                  setSelectedBuyerId={setSelectedBuyerId}
                  selectedBuyerId={selectedBuyerId}
                  showBackdrop={showBackdrop}
                  setShowBackDrop={setShowBackDrop}
                  isPopupOpen={isPopupOpen}
                  buyersId={buyerId}
                  openOwner={openOwner}
                  setOpenOwner={setOpenOwner}
                  open={open}
                  row={row}
                  userType={userType}
                  setOpen={setOpen}
                  isModalOpen={isModalOpen}
                  setIsModalOpen={setIsModalOpen}
                  index={indexValue}
                  expandFeedback={expandFeedback}
                  setExpandFeedback={setExpandFeedback}
                  isHiddenRightArrow={isHiddenRightArrow}
                  setIsHiddenRightArrow={setIsHiddenRightArrow}
                  position={position}
                  arrayCollection={arrayCollection}
                  data={data}
                  buyerId={value}
                  setBuyerId={setBuyerId}
                  setPosition={setPosition}
                  setArrayCollection={setArrayCollection}
                  rowData={row}
                  onShowChat={onShowChat}
                />
              )}
            </>
          );
        })
      ) : (
        <>
          {!expandFeedback && (
            <BuyersCard
              setSelectedBuyerId={setSelectedBuyerId}
              selectedBuyerId={selectedBuyerId}
              showBackdrop={showBackdrop}
              setShowBackDrop={setShowBackDrop}
              isPopupOpen={isPopupOpen}
              buyersId={buyerId}
              openOwner={openOwner}
              setOpenOwner={setOpenOwner}
              open={open}
              row={row}
              userType={userType}
              setOpen={setOpen}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              index={indexValue}
              expandFeedback={expandFeedback}
              setExpandFeedback={setExpandFeedback}
              isHiddenRightArrow={isHiddenRightArrow}
              setIsHiddenRightArrow={setIsHiddenRightArrow}
              position={position}
              arrayCollection={arrayCollection}
              data={data}
              buyerId={buyerId}
              setBuyerId={setBuyerId}
              setPosition={setPosition}
              setArrayCollection={setArrayCollection}
              rowData={row}
              onShowChat={onShowChat}
            />
          )}
        </>
      )}

      {(openFeedback || expandFeedback) && (
        <Feedback
          buyerId={buyerId}
          expandFeedback={expandFeedback}
          setExpandFeedback={setExpandFeedback}
          openFeedback={openFeedback}
          setOpenFeedback={setOpenFeedback}
          setUserName={setUserName}
          userName={userName}
          data={feedBackData}
          userType={userType}
          ownercardprop={userType == 'Vendor' ? true : false}
          marketShow={false}
          proid={0}
          userEmail={userEmail}
          address={address}
          setAddress={setAddress}
          directcomm={directcomm}
          index={null}
          row={feedBackData}
          buyerCardOpen={userType === 'Buyer' ? open : openOwner}
          setBuyerCardOpen={userType === 'Buyer' ? setOpen : setOpenOwner}
          userInitial={userInitial}
        />
      )}
      {totalPages > 10 && (
        <Stack sx={{ float: 'right' }} style={{ color: '#6C2AD2' }}>
          <Pagination
            className={PGcolor.root}
            sx={{ p: '20px 0' }}
            // count={pageCount}
            count={Math.ceil(totalPages / 10)}
            // defaultPage={page}
            page={page}
            onChange={handlePageChange}
          />
        </Stack>
      )}

      {modalIsOpen && <Moxochat open={modalIsOpen} onClose={setModalIsOpen} />}
      <Popover
        sx={{
          boxShadow: 'none',
          padding: 0,
          maxWidth: '600px',
        }}
        open={openPop}
        anchorEl={anchorEl}
        onClose={handleIconClick}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <TagPopOver
          postTagId={postTagId}
          setLoaderUser={setLoaderUser}
          LoaderTag={LoaderTag}
          setLoaderTag={setLoaderTag}
          userTagDetails={userTagDetails}
          setUserTagDetails={setUserTagDetails}
          tagArray={tagArray}
          setTagArray={setTagArray}
          Apifunctions={Apifunctions}
          LoaderUser={LoaderUser}
          userName={userName}
        />
      </Popover>
    </>
  );
}
